import * as React from "react";
import { Modal } from "antd";
import { CloseSvg } from "../../assets/customIcons";

import styles from "./Popup.module.scss";
import Spinner from "../Spinner";

interface IPopupProps {
  className?: string;
  title?: string | JSX.Element;
  open?: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  width?: number;
  footer?: React.ReactNode;
  mask?: boolean;
  centered?: boolean;
  loading?: boolean;
  style?: React.CSSProperties;
}

export const Popup: React.FC<IPopupProps> = ({
  className,
  title,
  open,
  onClose,
  children,
  style,
  footer = null,
  width,
  mask = false,
  centered = false,
  loading = false,
}) => {
  return (
    <Modal
      width={width}
      className={`${styles.popup} ${className}`}
      footer={footer}
      mask={mask}
      title={title}
      centered={centered}
      destroyOnClose
      visible={open}
      onCancel={onClose}
      closeIcon={<CloseSvg />}
      style={style}
    >
      {loading ? (
        <div style={{ minHeight: "200px" }}>
          <Spinner size="large" />
        </div>
      ) : (
        children
      )}
    </Modal>
  );
};
